<template>
    <div>
      <div v-if="isTransmitterLoaded">

      <!-- Confirm modal to remove the transmitter from the culture -->
      <div v-if="transmitter.culture !== null">

        <div>
          <button :disabled="true"  class="btn btn--danger"><i class="fas fa-minus-circle mr-2"></i>{{ $t('pages.transmitter_show.removeBtn') }}</button>
          <p class="text-gray-500 text-sm">
                <span>{{ $t('pages.visitor.warning') }}</span>
          </p>  
        </div>
        <!-- Transmitter details -->
        <div class="card mt-4 p-4 shadow-lg rounded-lg">
          <h2 class="card__title text-lg font-bold text-blue-600">
            {{ $t('pages.transmitter_show.cards.transmitter.title') }} 
            <span class="font-semibold">"{{ transmitter.id }}"</span>
          </h2>
          <div class="flex justify-between items-start mt-4">
            <div class="w-1/3">
              <div class="text-gray-600">
                <i class="fas fa-broadcast-tower mr-2"></i>{{ $t('pages.transmitter_show.cards.transmitter.type') }}:
              </div>
              <div class="text-gray-600">
                <i class="fas fa-leaf mr-2"></i>{{ $t('pages.transmitter_show.cards.transmitter.culture') }}:
              </div>
              <div class="text-gray-600">
                <i class="fas fa-clock mr-2"></i>{{ $t('pages.transmitter_show.cards.transmitter.lastActivityAt') }}:
              </div>
              <div class="text-gray-600">
                <i class="fas fa-battery-half mr-2"></i>{{ $t('pages.transmitter_show.cards.transmitter.battery') }}:
              </div>
              <div class="text-gray-600">
                <i class="fas fa-calendar-check mr-2"></i>{{ $t('pages.transmitter_show.cards.transmitter.lastMeasureAt') }}:
              </div>
            </div>
  
            <div class="ml-4 w-2/3 font-semibold">
              <div class="text-gray-800">
                {{ $t('backend_trans_keys.' + transmitter.typeTransKey) }}
              </div>
              <div class="text-gray-800">
                {{ transmitter.culture === null ? this.$t('words.none') : transmitter.culture.name + " (" + this.$t('backend_trans_keys.' + transmitter.culture.typeTransKey) + " " + this.$t('backend_trans_keys.' + transmitter.culture.varietyTransKey) + ")" }}
              </div>
              <div class="text-gray-800">
                {{ transmitter.lastSeenAt == null ? this.$t('words.never') : this.lastSeenAt(transmitter.lastSeenAt) }}
              </div>
              <div class="text-gray-800">
                {{ batteryLevel }}
              </div>
              <div class="text-gray-800">
                {{ transmitter.lastMeasureAt == null ? this.$t('words.never') : this.lastSeenAt(transmitter.lastMeasureAt) }}
              </div>
            </div>
          </div>
        </div>
  
        <!-- Linked sensors -->
        <div class="card mt-4">
          <h2 class="card__title">{{ $t('pages.transmitter_show.cards.sensors.title', {"count": transmitter.sensors.length}) }}</h2>
          <data-table :columns="sensorsTable.columns" :data="sensorsTable.data" />
        </div>
  
        <!-- Charts -->
        <div v-if="isTransmitterHasCultureAndSensor">
          <div class="mt-4">
            <button v-if="selectedTimePeriod !== 5" @click="refreshCharts" class="mr-4 btn btn--primary"><i class="fas fa-sync" :class="{ 'fa-spin': loadingMeasures }"></i></button>
            <!-- CSV download-->
            <button :disabled="true" class="btn btn--primary relative">
              <i class="fas fa-download mr-2"></i> CSV
            </button>        
            <p class="text-gray-500 text-sm">
              <span>{{ $t('pages.visitor.warning') }}</span>
            </p>
          </div>
          <select-time-period :default-value="selectedTimePeriod" :default-show-data-picker="showDatePicker" :default-start-date="startDate" :default-end-date="endDate" @valueChanged="timePeriodChanged" @submitCustomDate="submitCustomPeriod" class="mt-3"/>
        
          <div v-if="isMeasuresLoaded">
            <div v-for="measureType in measureTypes" :key="measureType.id" class="card mt-5">
              <div class="overflow-x-auto">
                <div style="min-width: 600px">
                  <highcharts :options="measureType.chartOptions" ref="lineCharts" constructor-type="chart"/>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      </div>
  
    </div>
  </template>
  
  <script>
  import DataTable from "../../../components/general/datatable/data-table";
  import SelectTimePeriod from "../../../components/charts/SelectTimePeriod";
  import {
    apiGetRequest,
    displayAlertError,
    displayDateTimestampByLocale, displayElapsedTimeToTimestamp,
    getLetterForSensor
  } from "../../../utils";
  import {
    NODE_VISITOR,WEATHER_VISITOR,API_TRANSMITTERS_MEASURES_SUFFIX
  } from "../../../utils/constants";
  import {getFromAndToQueryParam, getFromQueryParam, getLineChartOptionsByMeasureType} from "../../../utils/chartUtils";
  
  export default {
    name: "VisitorTransmiterShow",
    components: {DataTable, SelectTimePeriod},
    data: function() {
      return {
        id: this.$route.params.id,
        isTransmitterLoaded: false,
        transmitter : {},
        sensorsTable : {
          columns: {
            id: this.$t('words.id'),
            letter: this.$t('words.letter'),
            channel: this.$t('words.channel'),
            type: this.$t('words.type'),
            actions: this.$t('words.actions')
          },
          data: null
        },
        loadingCSV: false,
        selectedTimePeriod: 1,
        showDatePicker: false,
        startDate:"",
        endDate:"",
        loadingMeasures: false,
        isMeasuresLoaded: false,
        measureTypes : {},
        removeModal: {
          isVisible: false,
        }
      }
    },
    mounted() {
      this.isTransmitterLoaded = false
      let request = NODE_VISITOR
      if(this.$route.fullPath == "/VisitorNode")
      {
        request = NODE_VISITOR
      }
      else
      {
        request = WEATHER_VISITOR
      }
      apiGetRequest(request)
          .then((res) => {
            this.transmitter = res.data
            this.sensorsTable.data = this.transmitter.sensors.map((s) => {
              s.letter = getLetterForSensor(s.id)
              s.type = this.$t('backend_trans_keys.'+s.typeTransKey)
              s.actions = {}
              return s
            })
  
            this.isTransmitterLoaded = true
  
            if(this.isTransmitterHasCultureAndSensor){
              this.refreshCharts()
            }
          })
    },
    computed: {
      isTransmitterHasCultureAndSensor: function(){
        return this.transmitter.culture !== null && this.transmitter.sensors.length > 0
      },
      batteryLevel: function() {
        let lastBatteryAt = this.transmitter.lastBatteryAt === null ? "" : "(" + this.displayDate(this.transmitter.lastBatteryAt) + ")"
        return this.transmitter.lastBatteryAt == null ? this.$t('words.unknown') : this.transmitter.batteryPct + " % " + lastBatteryAt
      }
    },
    methods: {

  
      timePeriodChanged: function(selectedTimePeriod){
        this.selectedTimePeriod = selectedTimePeriod
        if(selectedTimePeriod !== 5){
          this.refreshCharts()
          this.showDatePicker = false
        }else{
          this.showDatePicker = true
        }
      },
      submitCustomPeriod: function(rangeDates){
        this.startDate = rangeDates.start
        this.endDate = rangeDates.end
        const fromAndToQueryParams = getFromAndToQueryParam(rangeDates)
        this.fetchUpdatedData(fromAndToQueryParams)
  
      },
    /**
         * Ask the API to fetch all measures according the selected time period, and display all charts.
         * We fetch each time the whole wanted data, not only the new one (if we refresh multiple time)
         * todo later : fetch only new data, according the last loaded value
         */
        fetchUpdatedData : function(queryParams){
        if(!this.loadingMeasures) {
            this.isMeasuresLoaded = false
            this.measureTypes = {}
            this.loadingMeasures = true
            apiGetRequest(NODE_VISITOR + API_TRANSMITTERS_MEASURES_SUFFIX + queryParams)
                .then((res) => {
                // console.log(res)
                this.updateMeasureTypes(res.data)
                this.isMeasuresLoaded = true
                })
                .finally(() => this.loadingMeasures = false)
        }
    },
      refreshCharts: function() {
        const fromQueryParam = getFromQueryParam(this.selectedTimePeriod)
        this.fetchUpdatedData(fromQueryParam)
      },
      /**
       * Update (extends) the local measureTypes variable to add all measures data provided by the API.
       * The updated value will contain all data and options for the chart displaying
       * @param data All measures data provided by the API
       */
      updateMeasureTypes: function(data) {
        this.measureTypes = data
  
        for (const key in this.measureTypes) {
          const measureType = this.measureTypes[key]
          // Error may be possible when chart export, if we have an old browser
          measureType["chartOptions"] = getLineChartOptionsByMeasureType(measureType, () => {
            const errorMsg = this.$t('pages.sensor_show.error-export')
            displayAlertError(errorMsg)
          })
        }
      },
      /**
       * From a specific timestamp, return a string representation of the elapsed time (xx minutes ago, ...)
       * We use moment.js and the current locale() load in moment.js for the language (according the chosen locale in the app)
       * @param lastSeenAtTimestamp Timestamp value of the last seen at
       * @returns {string} A string representation of the elapsed time (generate by moment js)
       */
      lastSeenAt: function(lastSeenAtTimestamp) {
        return displayElapsedTimeToTimestamp(lastSeenAtTimestamp)
      },
      /**
       * Display date by moment.js locale
       * @param date The date to display in timestamp
       * @returns {string} A string representation of the date, well formatted by the current locale
       */
      displayDate: function(date) {
        return displayDateTimestampByLocale(date)
      },
      /**
       * Toggle the remove transmitter modal
       */
      toggleRemoveModal: function() {
        this.removeModal.isVisible = !this.removeModal.isVisible
      },

    }
  }
  </script>
  
  <style scoped>
  
  .btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .card {
    background-color: #f8f9fa; /* Light background */
  }
  
  .card__title {
    border-bottom: 2px solid #8f9dac; /* Highlight the title */
    padding-bottom: 10px;
    text-decoration: none;
  }
  </style>